// extracted by css-extract-rspack-plugin
export default {"rangeContainer":"budget-module__rangeContainer","priceText":"budget-module__priceText"};